import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const initHomeBlogSlider = () => {
    const slider = document.querySelector('[data-blog-swiper]');
    if (!slider) return;

    const isMobile = () => window.innerWidth < 1024;
    let instance = null;

    const build = () => {
        if (!isMobile() || instance) return;

        const swiperEl = slider.querySelector('.swiper');
        const pagination = slider.querySelector('.HomeBlogSlider__pagination');

        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

        instance = new Swiper(swiperEl, {
            modules: [Navigation, Pagination],
            slidesPerView: 1.1,
            spaceBetween: 12,
            centeredSlides: false,
            initialSlide: 0,
            loop: false,
            pagination: {
                el: pagination,
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1.4,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 1.6,
                },
            },
        });
    };

    const destroy = () => {
        if (instance && !isMobile()) {
            instance.destroy(true, true);
            instance = null;
        }
    };

    build();
    window.addEventListener('resize', () => {
        destroy();
        build();
    });
};

document.addEventListener('DOMContentLoaded', initHomeBlogSlider);
